import { lazy, Suspense, type ReactNode } from 'react';
import { cx, SURFACE_GRAIN } from '@wapharma/design-system';
import styles from './auth-layout.module.css';

const AuthBrandFlowMesh = lazy(() =>
  import('../flow-mesh/FlowMesh').then((m) => ({ default: m.FlowMesh })),
);

type AdminAuthLayoutProps = {
  children: ReactNode;
  brandTitle?: string;
  brandBody: string;
};

function BrandFlowMesh() {
  return (
    <Suspense fallback={null}>
      <AuthBrandFlowMesh mode="hero" />
    </Suspense>
  );
}

export function AdminAuthLayout({
  children,
  brandTitle = 'Espace administration',
  brandBody,
}: AdminAuthLayoutProps) {
  const year = new Date().getFullYear();

  return (
    <div className={styles.root}>
      <aside className={styles.brandPanel} aria-label="WaPharma">
        <div className={styles.brandAmbient} aria-hidden>
          <div className={styles.brandBase} />
          <div className={`${styles.orb} ${styles.orbMenthol}`} />
          <div className={`${styles.orb} ${styles.orbTeal}`} />
          <div className={`${styles.orb} ${styles.orbMint}`} />
          <div className={`${styles.orb} ${styles.orbDeep}`} />
          <div className={styles.brandFlowLayer}>
            <BrandFlowMesh />
          </div>
          <div className={styles.brandGrain} />
        </div>

        <div className={styles.brandContent}>
          <div>
            <img
              src="/logo-light.svg"
              alt="W.A. Pharma"
              className={styles.brandLogo}
            />
          </div>
          <div>
            <p className={styles.brandTitle}>{brandTitle}</p>
            <p className={`${styles.brandBody} ${styles.brandBodySpaced}`}>
              {brandBody}
            </p>
          </div>
        </div>

        <p className={styles.brandCopyright}>© {year} W.A. Pharma</p>
      </aside>

      <div className={cx(styles.formColumn, SURFACE_GRAIN.overlay)}>
        <div className={styles.formWrap}>
          <div className={styles.mobileBrand} aria-label="WaPharma">
            <div className={styles.mobileBrandAmbient} aria-hidden>
              <div className={styles.mobileBrandFlow}>
                <BrandFlowMesh />
              </div>
            </div>
            <img
              className={styles.mobileBrandLogo}
              src="/logo-light.svg"
              alt="W.A. Pharma"
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
